import { apiClient } from "./client";

/**
 * Search APPROVED institutions for the verifier picker. Returns the minimum
 * shape needed for the dropdown: { id, name, city, state, registrationNumber }.
 *
 * @param {string} q - optional search query (matches name, city, registration number)
 * @param {number} limit - cap on results, max 50
 */
export async function searchInstitutions(q = "", limit = 20) {
  const res = await apiClient.get("/institutions/search", {
    params: { q, limit },
  });
  return res.data;
}

/** Institution officer's dashboard summary. */
export async function fetchInstitutionDashboard() {
  const res = await apiClient.get("/institution/dashboard");
  return res.data;
}

/** Update institution profile: logoUrl, description, websiteUrl */
export async function updateInstitutionProfile(dto) {
  const res = await apiClient.patch("/institution/profile", dto);
  return res.data;
}

/**
 * Live "is this registration number already taken?" check used by the
 * registration form as the user types. Public -- no auth required.
 * Returns { exists: boolean, name?: string, status?: string }.
 */
export async function checkInstitutionAvailability(registrationNumber) {
  const res = await apiClient.get("/institutions/check-availability", {
    params: { registrationNumber },
  });
  return res.data;
}

/**
 * Replace the institution's registration document after a rejection.
 * Pass the s3Key returned by /storage/upload-url. Flips status back to
 * PENDING_REVIEW and clears the previous rejection reason.
 */
export async function resubmitInstitutionDocument(s3Key) {
  const res = await apiClient.post(
    "/institution/resubmit-registration-document",
    { s3Key },
  );
  return res.data;
}
